export const AI_MATE_URL = '/gateway/api/assist/chat/v1/invoke_agent';
